<template>
  <section class="overflow-hidden">
    <v-card width="100vw">
      <v-row justify="center">
        <v-col cols="auto" max-width="33vw">
          <v-row justify="center" align="center">
            <v-col cols="auto">
              <v-row justify="center" no gutters>
                <h1 class="text-center h1">{{ title }}</h1>
              </v-row>
              <v-row justify="center" no gutters>
                <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row justify="center" align="center" data-aos="zoom-in">
                <v-col
                  v-for="(item, key, index) in boxesData"
                  :key="index"
                  cols="auto"
                >
                  <v-card
                    class="mx-auto card"
                    v-if="index != 0"
                    min-width="400"
                    min-height="400"
                    max-width="80vw"
                    :elevation="10"
                    color="darkGrey"
                    :shaped="true"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="auto">
                        <v-row justify="center">
                          <v-card-title class="text-center font-weight-bold">{{
                            item.name
                          }}</v-card-title>
                        </v-row>

                        <v-row justify="center">
                          <v-icon class="card-icon" x-large>
                            {{ item.icon }}</v-icon
                          >
                        </v-row>
                        <v-row justify="center">
                          <v-list max-width="80%">
                            <v-list-item
                              max-width="100%"
                              v-for="(i, idx) in item.rows"
                              :key="idx"
                            >
                              <v-container>
                                <v-row justify="center" no-gutters>
                                  <v-col cols="auto">
                                    <v-list-item-title
                                      class="ma-2 text-center font-weight-bold h2"
                                      >{{ i.title }}</v-list-item-title
                                    >
                                  </v-col>
                                </v-row>
                                <v-row justify="center" no-gutters>
                                  <v-col cols="auto">
                                    <p
                                      class="ma-2 text-center font-weight-bold caption"
                                    >
                                      {{ i.subtitle }}
                                    </p>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-list-item>
                          </v-list>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>
<script>
export default {
  name: "Boxes",
  props: {
    boxesData: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  border-radius: 25px;
  border-top: 2px solid var(--v-info-base);
  border-bottom: 2px solid var(--v-info-base);
}

@media (min-width: 1024) {
  .card {
    border-left: 2px solid var(--v-info-base);
    border-right: 2px solid var(--v-info-base);
  }
}

.card:hover {
  color: var(--v-primary-base);
}

.card-icon:hover {
  color: var(--v-primary-base);
}

#card-text:hover {
  text-decoration: underline;
}
</style>
